import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

interface SwitchProps {
  attr?: string
  isReturnJourney: boolean // true = Return journey, false = Outbound only
  name?: string
  onChange: (val: boolean) => void
}

export const JourneySwitch: React.FC<SwitchProps> = ({ attr, isReturnJourney, name, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className="gap-semantic-global-2xs flex flex-col">
      <label className="typography-body-sm-regular">{t('JOURNEY-TYPE')}</label>
      <div
        aria-label="Journey type switch"
        className="bg-semantic-global-background-white p-semantic-global-2xs border-semantic-global-border-light inline-flex overflow-hidden border"
        data-e2e={attr}
        role="group"
      >
        <button
          className={clsx(
            'px-semantic-global-sm py-semantic-global-xs w-full cursor-pointer transition-colors',
            !isReturnJourney
              ? 'bg-semantic-global-background-light-sky-blue typography-body-sm-medium text-semantic-global-text-default cursor-pointer'
              : 'bg-semantic-global-background-white typography-body-sm-regular text-semantic-global-text-light'
          )}
          data-e2e="oneway-button"
          data-e2e-checked={!isReturnJourney}
          name={name}
          onClick={() => isReturnJourney && onChange(false)}
          type="button"
        >
          {t('OUTBOUND-ONLY')}
        </button>
        <button
          className={clsx(
            'px-semantic-global-sm py-semantic-global-xs w-full cursor-pointer transition-colors',
            isReturnJourney
              ? 'bg-semantic-global-background-light-sky-blue typography-body-sm-medium text-semantic-global-text-default'
              : 'bg-semantic-global-background-white typography-body-sm-regular text-semantic-global-text-light'
          )}
          data-e2e="return-button"
          data-e2e-checked={isReturnJourney}
          name={name}
          onClick={() => !isReturnJourney && onChange(true)}
          type="button"
        >
          {t('RETURN-JOURNEY')}
        </button>
      </div>
    </div>
  )
}
